<app-browser-header></app-browser-header>

<ion-content>
  <div class="home-page-section header-image">
    <div class="home-page-section-content header-image-content">
      <div class="header-image-start">
        <p class="header-title">{{ "BROWSER_HOME_PAGE.HEADER_TITLE" | translate }}</p>
        <p class="header-description">{{ "BROWSER_HOME_PAGE.HEADER_DESCRIPTION" | translate }}</p>
      </div>
      <div class="header-image-end">
        <p class="title">{{ "BROWSER_HOME_PAGE.DELIVERY_ADDRESS" | translate }}</p>

        <div class="form-container" [class.with-value]="selectedAddress">
          <div tappable (click)="onOpenAreaSelectionModal()" class="area-field">
            <p *ngIf="selectedAddress" class="area-field-value">
              {{ selectedAddress.name ? selectedAddress.name : selectedAddress.area.name }}
            </p>
            <p *ngIf="!selectedAddress" class="area-field-placeholder">{{ "BROWSER_HOME_PAGE.SELECT_AREA_PLACEHOLDER" | translate }}</p>
            <ion-icon class="area-field-icon" src="/assets/custom-icons/vendors-page/chevron.svg"></ion-icon>
          </div>

          <ion-button color="green" class="custom-button submit-button" (click)="onContinue()">
            {{ "BROWSER_HOME_PAGE.CONTINUE_BUTTON" | translate }}
          </ion-button>
        </div>

        <ng-container *ngIf="!selectedAddress">
          <div class="separator">
            <div class="separator-line">
              <div class="separator-line-content"></div>
            </div>
            <div class="separator-text">{{ "BROWSER_HOME_PAGE.OR" | translate }}</div>
            <div class="separator-line">
              <div class="separator-line-content"></div>
            </div>
          </div>

          <p tappable class="skip" (click)="onSkipAreaSelection()">{{ "BROWSER_HOME_PAGE.SELECT_AREA_SKIP" | translate }}</p>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="home-page-section for-business">
    <div class="home-page-section-content for-business-content">
      <p class="home-page-section-title">{{ "BROWSER_HOME_PAGE.FOR_BUSINESS_TITLE" | translate }}</p>

      <div class="for-business-items">
        <div class="for-business-item">
          <div class="for-business-item-icon dedicacted-account-manager"></div>
          <p class="for-business-item-title">{{ "BROWSER_HOME_PAGE.FOR_BUSINESS_ACCOUNT_MANAGER_TITLE" | translate }}</p>
          <p class="for-business-item-description">{{ "BROWSER_HOME_PAGE.FOR_BUSINESS_ACCOUNT_MANAGER_DESCRIPTION" | translate }}</p>
        </div>
        <div class="for-business-item">
          <div class="for-business-item-icon custom-menus"></div>
          <p class="for-business-item-title">{{ "BROWSER_HOME_PAGE.FOR_BUSINESS_ACCOUNT_CUSTOM_MENUS_TITLE" | translate }}</p>
          <p class="for-business-item-description">{{ "BROWSER_HOME_PAGE.FOR_BUSINESS_ACCOUNT_CUSTOM_MENUS_DESCRIPTION" | translate }}</p>
        </div>
        <div class="for-business-item">
          <div class="for-business-item-icon flexible-payment-options"></div>
          <p class="for-business-item-title">{{ "BROWSER_HOME_PAGE.FOR_BUSINESS_ACCOUNT_PAYMENT_OPTIONS_TITLE" | translate }}</p>
          <p class="for-business-item-description">
            {{ "BROWSER_HOME_PAGE.FOR_BUSINESS_ACCOUNT_PAYMENT_OPTIONS_DESCRIPTION" | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="home-page-section trusted-by">
    <div class="home-page-section-content trusted-by-content">
      <p class="home-page-section-title">{{ "BROWSER_HOME_PAGE.TRUSTED_BY_TITLE" | translate }}</p>
      <img class="trusted-by-item-image" src="https://cdn.bilbayt.com/assets/managed-company-logos-636603314813570704.png" />
    </div>
  </div>

  <div class="home-page-section mobile-app">
    <div class="home-page-section-content mobile-app-content">
      <div class="mobile-app-start">
        <p class="title">{{ "BROWSER_HOME_PAGE.MOBILE_APP_TITLE" | translate }}</p>
        <p class="description">{{ "BROWSER_HOME_PAGE.MOBILE_APP_DESCRIPTION" | translate }}</p>

        <div class="app-links">
          <a
            tappable
            target="_blank"
            class="app-link app-store"
            href="https://itunes.apple.com/app/bilbayt/id1052726070?mt=8&utm_source=Bilbaytwebsite&utm_medium=websitereferral"
          >
          </a>
          <a
            tappable
            target="_blank"
            class="app-link google-play"
            href="https://play.google.com/store/apps/details?id=com.bilbayt.bilbayt&utm_source=Bilbaytwebsite&utm_medium=websitereferral"
          >
          </a>
        </div>
      </div>
      <div class="mobile-app-end">
        <div class="app-links">
          <a
            tappable
            target="_blank"
            class="app-link app-store"
            href="https://itunes.apple.com/app/bilbayt/id1052726070?mt=8&utm_source=Bilbaytwebsite&utm_medium=websitereferral"
          >
          </a>
          <a
            tappable
            target="_blank"
            class="app-link google-play"
            href="https://play.google.com/store/apps/details?id=com.bilbayt.bilbayt&utm_source=Bilbaytwebsite&utm_medium=websitereferral"
          >
          </a>
        </div>
      </div>
    </div>

    <div class="app-screenshot home-page"></div>
    <div class="app-screenshot vendor-details-page"></div>
  </div>

  <div class="home-page-section partners">
    <div class="home-page-section-content partners-content">
      <p class="home-page-section-title">{{ "BROWSER_HOME_PAGE.PARTNERS_TITLE" | translate }}</p>

      <div class="partners-images">
        <div
          class="partners-image"
          [style.backgroundImage]="'url(' + currentCountryPartnersLogosUrl + ')'"
          [style.backgroundPositionY.px]="0"
        ></div>
        <div
          class="partners-image"
          [style.backgroundImage]="'url(' + currentCountryPartnersLogosUrl + ')'"
          [style.backgroundPositionY.px]="-100"
        ></div>
        <div
          class="partners-image"
          [style.backgroundImage]="'url(' + currentCountryPartnersLogosUrl + ')'"
          [style.backgroundPositionY.px]="-200"
        ></div>
        <div
          class="partners-image"
          [style.backgroundImage]="'url(' + currentCountryPartnersLogosUrl + ')'"
          [style.backgroundPositionY.px]="-300"
        ></div>
        <div
          class="partners-image"
          [style.backgroundImage]="'url(' + currentCountryPartnersLogosUrl + ')'"
          [style.backgroundPositionY.px]="-400"
        ></div>
        <div
          class="partners-image"
          [style.backgroundImage]="'url(' + currentCountryPartnersLogosUrl + ')'"
          [style.backgroundPositionY.px]="-500"
        ></div>
        <div
          class="partners-image"
          [style.backgroundImage]="'url(' + currentCountryPartnersLogosUrl + ')'"
          [style.backgroundPositionY.px]="-600"
        ></div>
        <div
          class="partners-image"
          [style.backgroundImage]="'url(' + currentCountryPartnersLogosUrl + ')'"
          [style.backgroundPositionY.px]="-700"
        ></div>
      </div>
    </div>
  </div>

  <app-browser-footer></app-browser-footer>
</ion-content>
